import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { AnomalyCount } from '@/__generated__/graphql';

type CountWithEnumKey = AnomalyCount & { enumKey?: string };

export const CountsList = ({
  counts,
  colorMapper,
}: {
  counts: CountWithEnumKey[];
  colorMapper: (key: string) => string;
}) => {
  return (
    <>
      {counts.map((count) => (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          key={count.key}
          width="100%"
          data-testid="counts-list"
        >
          <Stack direction="row" alignItems="center" gap="0.6rem">
            <Box
              sx={{
                backgroundColor: colorMapper(count.enumKey ?? count.key ?? ''),
                width: '1rem',
                height: '1rem',
                borderRadius: '0.2rem',
              }}
            />
            <Typography
              fontSize="1.1rem"
              lineHeight="1.1rem"
              color={abyssColors.primary[300]}
              data-testid={`count-list-key-${count.key}`}
            >
              {count.key}
            </Typography>
          </Stack>
          <Box
            sx={{
              flex: '1 0',
              mx: '14px',
              height: '0.1rem',
              backgroundColor: abyssColors.primary[100],
            }}
          />
          <Typography
            fontSize="1.4rem"
            fontWeight={500}
            lineHeight="1.4rem"
            color={abyssColors.primary[400]}
            data-testid={`${count.key}-count`}
            minWidth={33}
            textAlign="right"
          >
            {count.count ?? 0}
          </Typography>
        </Stack>
      ))}
    </>
  );
};
